/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import flatMap from 'lodash/flatMap';
import get from 'lodash/get';
import {
    asyncDefaults,
    makeAsyncReducer,
    makeAsyncResetReducer,
    mergeReducers,
} from 'ui-permit/shared-components/utils/async';
import { PREFIX } from '../constants';
import * as ACTIONS from '../constants/actions';

const INITIAL_STATE = [];

const fetchAvailability = makeAsyncReducer(ACTIONS.FETCH_AVAILABILITY);
const resetAvailability = makeAsyncResetReducer(ACTIONS.RESET_AVAILABILITY, {});

const availability = mergeReducers(
    asyncDefaults(INITIAL_STATE),
    PREFIX,
    fetchAvailability,
    resetAvailability
);

export default availability;

export const selectors = {
    getAvailability: (state) => state.huntingpermit.availability.data,
    getDates: (state) =>
        flatMap(state.huntingpermit.availability.data, (d) => d.start_date.split(';')),
    getInventoryAvailable: (state) => (huntType, canSelectDate, startDate) => {
        const availForDay = state.huntingpermit.availability.data.find(
            ({ permit_type, start_date }) =>
                permit_type === huntType &&
                (canSelectDate ? start_date === startDate : true)
        );
        if (!availForDay) {
            return undefined;
        }
        const totalForAnyDivision = get(
            availForDay,
            'quota.ANY_DIVISION.available',
            undefined
        );
        if (totalForAnyDivision) {
            return totalForAnyDivision;
        }
        return Object.values(get(availForDay, 'quota', {})).reduce(
            (t, { available }) => t + available,
            0
        );
    },
    getAvailabilityStartDate: (state) => (huntType) =>
        get(
            state.huntingpermit.availability.data.find(
                ({ permit_type }) => permit_type === huntType
            ),
            'start_date',
            ''
        ),
    getAvailabilityError: (state) => {
        const { error, status } = state.huntingpermit.availability;
        if (error) return { status, error };
        return null;
    },
};
